import {IToJson} from '@toolify/client/src/types/IToJson'
import {
  IDatabaseTimeTrackerItemResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabaseTimeTrackerItemResponseInstance'
import {mapResponseEntity} from '@toolify/client/src/modules/api/singletons/mapResponseEntity'
import {mapDatabaseItemResponseInstance} from '@toolify/client/src/modules/api/singletons/mapDatabaseItemResponseInstance'

export function mapDatabaseTimeTrackerItemResponseInstance(
  databaseTimeTrackerItem: IToJson<IDatabaseTimeTrackerItemResponseInstance>,
): IDatabaseTimeTrackerItemResponseInstance {
  return {
    ...databaseTimeTrackerItem,
    startedAt: new Date(databaseTimeTrackerItem.startedAt),
    endedAt: databaseTimeTrackerItem.endedAt ? new Date(databaseTimeTrackerItem.endedAt) : null,
    authorEntity: databaseTimeTrackerItem.authorEntity ? mapResponseEntity(databaseTimeTrackerItem.authorEntity) : null,
    databaseItem: databaseTimeTrackerItem.databaseItem ? mapDatabaseItemResponseInstance(databaseTimeTrackerItem.databaseItem) : undefined,
  }
}
